import { Trash } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

interface UserActionsProps {
  userId: string;
  isAdmin: boolean;
  isActive: boolean;
  onRoleChange: (userId: string, makeAdmin: boolean) => Promise<void>;
  onStatusChange: (userId: string, makeActive: boolean) => Promise<void>;
  onDeleteUser: (userId: string) => Promise<void>;
}

const UserActions = ({
  userId,
  isAdmin,
  isActive,
  onRoleChange,
  onStatusChange,
  onDeleteUser,
}: UserActionsProps) => {
  return (
    <div className="flex flex-wrap justify-end gap-2">
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="rounded-lg border-gray-200 text-gray-700 hover:border-whatsapp hover:text-whatsapp"
        onClick={() => void onStatusChange(userId, !isActive)}
      >
        {isActive ? "Deactivate" : "Activate"}
      </Button>

      <Button
        type="button"
        variant="outline"
        size="sm"
        className="rounded-lg border-gray-200 text-gray-700 hover:border-whatsapp hover:text-whatsapp"
        onClick={() => void onRoleChange(userId, !isAdmin)}
      >
        {isAdmin ? "Remove admin" : "Make admin"}
      </Button>

      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="rounded-lg border-red-200 text-red-600 hover:bg-red-50 hover:text-red-700"
          >
            <Trash className="h-4 w-4" />
            Delete
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete user account</AlertDialogTitle>
            <AlertDialogDescription>
              This action cannot be undone. The authentication account and related profile data will be removed.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => void onDeleteUser(userId)}
              className="bg-red-500 hover:bg-red-700"
            >
              Delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default UserActions;
